import { FC, useCallback, MouseEvent, useRef, HTMLAttributes, TouchEvent } from 'react'
import Touchable from 'components/utils/Touchable'

type InteractionHandlerProps =
  & HTMLAttributes<HTMLElement>
  & {
    onInteraction: (x: number, y: number) => void
  }

export const InteractionHandler: FC<InteractionHandlerProps> = (props) => {
  const { children, onInteraction, ...restProps } = props

  const ref = useRef<HTMLDivElement>(null)

  const handleCords = useCallback<(x: number, y: number) => void>((x, y) => {
    const { current } = ref
    if (!current) {
      return
    }
    const rect = current.getBoundingClientRect()
    const left = x - rect.left
    const top = y - rect.top
    onInteraction(left, top)
  }, [onInteraction])

  const handleMouseMove = useCallback<(event: MouseEvent<HTMLDivElement>) => void>((event) => {
    const { clientX, clientY } = event
    handleCords(clientX, clientY)
  }, [handleCords])

  const handleTap = useCallback<(event: HammerInput) => void>((event) => {
    handleCords(event.center.x, event.center.y)
  }, [handleCords])

  const handleTouchMove = useCallback<(event: TouchEvent<HTMLDivElement>) => void>((event) => {
    const touch = event.touches[0]
    if (!touch) {
      return
    }
    const { clientX, clientY } = touch
    handleCords(clientX, clientY)
  }, [handleCords])

  return (
    <div ref={ ref } onMouseMove={ handleMouseMove } onTouchMove={ handleTouchMove } { ...restProps }>
      <Touchable onTap={ handleTap }>
        <div>
          { children }
        </div>
      </Touchable>
    </div>
  )
}
